












import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string
  @Prop({}) private colorList!: any
  @Prop({}) private dataList!: any

  private chartId: string = ''
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    console.info(this.dataList)
    this.option.series[0].data = this.dataList
  }
  private option: any = {
    color: this.colorList,
    legend: {
      top: '0',
      left: 'right',
      textStyle: {
        color: '#999999',
        fontSize: 12
      },
      icon: 'circle',
      itemWidth: 5,
      itemHeight: 5
    },
    animation: false,
    series: [{
      name: '',
      type: 'pie',
      radius: ['40%', '75%'],
      avoidLabelOverlap: false,
      top: 50,
      labelLine: {
        show: true
      },
      label: {
        show: true,
        formatter: function(value, indicator) {
          const p = value.percent
          return `${p}%`
        }
      },
      itemStyle: {
        borderColor: '#FFFFFF'
      },
      data: [
      ]
    }]
  }
}
